import React from "react";
import { createRoot } from "react-dom/client";
import { AppStoresFactory } from "../shared-components/AppStoresFactory";
import { UploadMasterComponent } from "./UploadMasterComponent";
import { AppUploadFactory } from "./AppUploadFactory";
import type { IUploadIndexViewModel } from "./network/contracts/IUploadIndexViewModel";

const appStoresFactory = new AppStoresFactory();
const appUploadFactory = new AppUploadFactory();

export async function initializeUpload(uploadViewModel: IUploadIndexViewModel) {
    const appStores = await appStoresFactory.create(uploadViewModel);
    const appUpload = await appUploadFactory.createMaster(uploadViewModel, appStores);

    const rootElement: HTMLElement = document.getElementById("app-root")!;
    const root = createRoot(rootElement);

    root.render(<UploadMasterComponent appUpload={appUpload} />);

    return appUpload;
}

window["initializeUpload"] = initializeUpload;
